import { SearchX } from 'lucide-react';

import { useQuery } from '@/helpers/useQuery';

import Page from '@/components/layout/Page';
import HeaderWithBack from '@/components/common/HeaderWithBack';
import Loader from '@/components/common/Loader';
import Error from '@/components/common/Error';
import {
  Empty,
  EmptyIcon,
  EmptyTitle,
  EmptyDescription
} from '@/components/ui/empty';

import { useCoaches } from '@/data/coach';

import CoachCard from './CoachCard';

const CoachListPage = () => {
  const activityId = useQuery('activityId');
  const coaches = useCoaches({ activityId });

  if (coaches.isLoading && !coaches.data) {
    return (
      <Page>
        <HeaderWithBack to="/" title="Home" />
        <div className="flex justify-center items-center h-[calc(100vh-180px)]">
          <Loader />
        </div>
      </Page>
    );
  }

  if (coaches.error) {
    return (
      <Page>
        <HeaderWithBack to="/" title="Home" />
        <div className="flex justify-center items-center h-[calc(100vh-180px)]">
          <Error error="There was an error loading coaches" />
        </div>
      </Page>
    );
  }

  if (coaches.data.length === 0) {
    return (
      <Page>
        <HeaderWithBack to="/" title="Home" />
        <div className="py-8">
          <Empty>
            <EmptyIcon>
              <SearchX />
            </EmptyIcon>
            <EmptyTitle>No Pros yet!</EmptyTitle>
            <EmptyDescription>Try selecting a different sport</EmptyDescription>
          </Empty>
        </div>
      </Page>
    );
  }

  return (
    <Page>
      <HeaderWithBack to="/" title="Home" />
      <div className="flex flex-col gap-4 pb-8">
        {coaches.data.map((coach) => (
          <CoachCard key={coach.id} coach={coach} />
        ))}
      </div>
    </Page>
  );
};

export default CoachListPage;
